import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService, RmsRequestResult } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class MailingService {

  constructor(private api: ApiService) {    
  }

  send(request: MailRequest): Observable<boolean> {
    return this.api.rms<MailRequest, boolean>("pom.common.mail", request, i => false).pipe<boolean>(map(response => response.Result == RmsRequestResult.OK && response.Data));
  }
}

export interface MailAttachment {
  FileName: string;
  Base64Content: string;
}

export interface MailRequest {
  Receivers: string[];
  Name: string;
  Subject: string;
  Content: string;
  Attachments: MailAttachment[];
  Account: 'info' | 'accounting' | 'report';
}
